<div class="d-flex flex-row justify-content-center align-items-center" style="height: 54px;">
   Copyright © {{ year }} Rekbot Sp. z o.o. Wszelkie prawa zastrzeżone
</div>
